import { gql } from '@apollo/client'

export const DROP_OFF_CHANNEL_FRAGMENT = gql`
  fragment DropOffChannel on DropOffChannel {
    handle
    name
    note
  }
`
